import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import Paragraph from '../../Paragraph';
import Button from '../../Button';
import { renderField } from '../../Inputs';
import { Row } from '../../Register/Scaffold';

const selectableData = {
  editable: 0,
  options: [
    { id: 8081, key: 'weight', value: 'weight management' },
    { id: 8082, key: 'activity', value: 'becoming more active' },
    { id: 8083, key: 'smoking', value: 'stopping smoking' },
    { id: 8084, key: 'alcohol', value: 'drinking less alcohol' },
    { id: 8085, key: 'unknown', value: "don't know" },
  ],
  value: '',
};

class ChangeArea extends React.PureComponent {
  componentDidMount() {

  }

  render() {
    const { prevPage, handleSubmit } = this.props;

    return (
      <Row classes="drinking-less images-container">
        <Paragraph classes="images extraMargin" center>
          <img src="https://livewelldorset.s3.amazonaws.com/Pathways/getactive-roundal.png" alt="" width="100" height="100" />
          <img src="https://livewelldorset.s3.amazonaws.com/Pathways/loseweight-roundal.png" alt="" width="100" height="100" />
          <img src="https://livewelldorset.s3.amazonaws.com/Pathways/quitsmoking-roundal.png" alt="" width="100" height="100" />
          <img src="https://livewelldorset.s3.amazonaws.com/Pathways/drink-less.png" alt="" width="100" height="100" />
        </Paragraph>
        <form onSubmit={handleSubmit} className="form-register">
          <Paragraph classes="section-text alcohol-unit-section" center><strong>Which areas of your lifestyle you have been working on changing? (please tick all that apply)</strong></Paragraph>
          <Field
            name="assessment[review_areas]"
            type="checkboxgroup"
            component={renderField}
            params={{ data: selectableData, name: 'assessment[review_areas]' }}
            centered
          />

          <Paragraph classes="button-groups divideline" center>
            <Button classes={['color-button']} label="Next" onClick={handleSubmit} />
            <Button classes={['underline-button']} label="Back" onClick={prevPage} />
          </Paragraph>
        </form>
      </Row>
    );
  }
}

ChangeArea.propTypes = {
  prevPage: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'assessment', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(ChangeArea);



// WEBPACK FOOTER //
// ./src/Components/Assessment/Pages/ChangeArea.jsx